/**
 * exp/trending-topic-slider — Swiper (scoped per block instance).
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

const roots = document.querySelectorAll('.exp-trending-slider');

roots.forEach((root) => {
	const el = root.querySelector('.swiper-container-trending-slider');

	if (!el) {
		return;
	}

	const prevEl = root.querySelector('.swiper-button-prev');
	const nextEl = root.querySelector('.swiper-button-next');

	// eslint-disable-next-line no-new
	new Swiper(el, {
		modules: [Navigation],
		loop: false,
		slidesPerView: 1.2,
		slidesToScroll: 1,
		spaceBetween: 24,
		watchOverflow: true,
		navigation: {
			prevEl: prevEl || null,
			nextEl: nextEl || null,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.25,
				slidesToScroll: 1,
			},
			1024: {
				slidesPerView: 4,
				slidesToScroll: 1,
			},
		},
	});
});
